import styled from '@emotion/styled'
import * as React from 'react'

import Loader from 'main/components/common/Loader'

const Container = styled.div`
  display: flex;
  margin: auto;
`

export default function ContentLoader() {
  return (
    <Container>
      <Loader collapse />
    </Container>
  )
}
